import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Table } from 'flowbite-react';
import { BiCheck, BiX } from 'react-icons/bi';
import { setBenefitList, addBenefit } from '../redux/benefitList/benefitSlice';
import axios from 'axios';

const Benefit = () => {
  const dispatch = useDispatch();
  const { benefitList = [], loading = false } = useSelector((state) => state.benefits || {});
  const { currentUser } = useSelector((state) => state.user || {});
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBenefits = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}benefit/getallBenefit`,
          { applicantId: currentUser?._id },
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        console.log('API Response:', response.data); // Debug the response
        dispatch(setBenefitList(response.data.data || [])); // Ensure data is an array
      } catch (err) {
        setError(err.message || 'Failed to fetch benefits');
        toast.error('Failed to fetch benefits');
      }
    };
    if (currentUser?._id) fetchBenefits();
  }, [dispatch, currentUser?._id]);

  // Handle approve action
  const handleApprove = async (benefitId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}benefit/updateBenefit`,
        { benefitId, benefitStatus: 'Approved' },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      dispatch(addBenefit(response.data.data));
      toast.success('Benefit approved successfully');
    } catch (err) {
      toast.error('Failed to approve benefit');
    }
  };

  // Handle decline action
  const handleDecline = async (benefitId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}benefit/updateBenefit`,
        { benefitId, benefitStatus: 'rejected' },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      dispatch(addBenefit(response.data.data));
      toast.success('Benefit declined successfully');
    } catch (err) {
      toast.error('Failed to decline benefit');
    }
  };

  if (loading) return <div className="p-4 text-center">Loading...</div>;
  if (error) return <div className="p-4 text-red-500">{error}</div>;

  return (
    <div className="p-4 bg-white rounded-lg shadow w-fit">
      <Table className="w-full border-collapse">
        <Table.Head className="bg-gray-200 w-full">
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">S/N</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Name</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Email</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Balance</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Amount Requested</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Date Requested</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Reason</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Status</Table.HeadCell>
          <Table.HeadCell className="px-6 py-3 text-left text-xs font-medium text-gray-700 uppercase tracking-wider">Action</Table.HeadCell>
        </Table.Head>
        <Table.Body>
          {benefitList.map((benefit, index) => {
            // Log each benefit to debug
            console.log(`Benefit ${index}:`, benefit);
            return (
              <Table.Row
                key={benefit?._id}
                className={`border-t ${
                  benefit?.benefitStatus === 'Pending'
                    ? 'bg-yellow-50'
                    : benefit?.benefitStatus === 'Approved'
                    ? 'bg-green-50'
                    : benefit?.benefitStatus === 'rejected'
                    ? 'bg-red-50'
                    : ''
                }`}
              >
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  {index + 1}
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  {benefit?.applicantId?.firstName || 'Unknown'}{' '}
                  {benefit?.applicantId?.lastName || ''}
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  {benefit?.applicantId?.email }
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  N{benefit?.benefitBalance || '0'}
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  N{benefit?.amountRequested || '0'}
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  {new Date(benefit?.createdAt).toLocaleDateString() || '0'}
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  {benefit?.benefitDescription || 'N/A'}
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  <span
                    className={`flex w-full items-center justify-center ${
                      benefit?.benefitStatus === 'Approved'
                        ? 'text-green-600'
                        : benefit?.benefitStatus === 'rejected'
                        ? 'text-red-600'
                        : 'text-yellow-600'
                    }`}
                  >
                    {benefit?.benefitStatus || 'Unknown'}
                  </span>
                </Table.Cell>
                <Table.Cell className="border-gray-200 text-xs font-medium text-gray-600 px-6 py-4">
                  {benefit?.benefitStatus === 'Pending' && (
                    <div className="flex items-center justify-center space-x-2">
                      <Button
                        className="bg-green-500 py-2 text-white rounded-sm"
                        onClick={() => handleApprove(benefit?._id)}
                      >
                        <BiCheck /> Approve
                      </Button>
                      <Button
                        className="bg-red-500 py-2 text-white rounded-sm"
                        onClick={() => handleDecline(benefit?._id)}
                      >
                        <BiX /> Decline
                      </Button>
                    </div>
                  )}
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default Benefit;